<template>
  <el-dialog
    :visible.sync="_show"
    title="File Uploader"
  >
    <el-upload
      :limit="uploadFilesLimit"
      :action="uploadUrl"
      :name="uploadKeyName"
      :headers="uploadHeader"
      :before-upload="handleBeforeUpload"
      :on-exceed="handleUploadLimitExceed"
      :on-preview="handlePreviewFile"
      :on-success="handleUploadSuccessed"
      :show-file-list="false"
      drag
      multiple
    >
      <i class="el-icon-upload"/>
      <div
        class="el-upload__text"
        v-html="$t('file.dropFileHereOrClickUpload')"
      />
      <div
        slot="tip"
        class="el-upload__tip"
      >
        {{ $t('file.sizeLessThan100MB') }}
      </div>
    </el-upload>

    <ul
      v-loading="isUploading"
      class="file-list"
    >
      <li
        v-for="file in fileList"
        :key="file.uid"
      >
        <div @click="handlePreviewFile(file)">
          {{ file.name }}
        </div>

        <el-button
          v-clipboard:copy="file.imgUrl"
          v-clipboard:success="handleCopySuccess"
          class="copy-embed-code-button"
          type="primary"
          size="mini"
        >Copy</el-button>
      </li>
    </ul>

    <el-button
      type="primary"
      size="mini"
      @click="handleClear"
    >Clear</el-button>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'

import clipboard from '@/directive/clipboard'

export default {
  name: 'FileUploaderModal',
  directives: {
    clipboard,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      uploadFilesLimit: 20,
      fileList: [],
      isUploading: false,
    }
  },
  computed: {
    ...mapGetters({
      token: 'user/token',
    }),
    uploadUrl() {
      return `${process.env.VUE_APP_API_BASE_URL}/upload`
    },
    uploadHeader() {
      return {
        Authorization: `Bearer ${this.token}`,
      }
    },
    uploadKeyName() {
      return 'file'
    },
    _show: {
      get() {
        return this.show
      },
      set() {
        this.$emit('close')
      },
    },
  },
  methods: {
    handleBeforeUpload(file) {
      const isLessThan100MB = file.size / 1024 / 1024 < 100
      if (!isLessThan100MB) {
        this.$message.error('File size must be less than 100MB')
      }
      if (isLessThan100MB) {
        this.isUploading = true
      }
      return isLessThan100MB
    },
    handleUploadLimitExceed() {
      this.$message.error(`You can only upload a maximum of ${this.uploadFilesLimit} files at a time.`)
      this.isUploading = false
    },
    handleUploadSuccessed(_, __, fileList) {
      this.$store.dispatch('file/getFileList')

      this.fileList = fileList.map(file => ({
        name: file.name,
        uid: file.uid,
        imgUrl: file.response.data.img_url,
      }))
      this.isUploading = false
    },
    async handlePreviewFile(file) {
      if (file.status !== 'success') return

      try {
        const link = file.response.data.img_url
        await this.$alert(link, 'File Link')
      } catch (error) {
        console.log(error)
      }
    },
    handleClear() {
      this.fileList = []
    },
    handleCopySuccess() {
      this.$message('Copied Link Successfully')
    },
  },
}
</script>

<style lang="scss" scoped>
.uploader-wrapper {
  display: flex;
  align-items: center;
  flex-flow: column;
  padding: 5px;
}

.file-list {
  padding: 0 8px;
  li {
    display: flex;
    justify-content: space-between;
    align-items: center;

    padding: 4px;
    margin-bottom: 2px;
    &:hover {
      background-color: rgba(0,0,0, .05);
    }
  }
}
</style>
